import React, { useState, useEffect } from "react";

import { visitorManagementData } from "../utils/visitorManagementCarauselData";

const VisitorManagementCarausel = () => {
  const [slideNo, setSlideNo] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setSlideNo(slideNo === 4 ? 0 : slideNo + 1);
    }, 2500);
    return () => {
      return clearInterval(interval);
    };
  }, [slideNo]);

  return (
    <div className="container pb-5">
      

      <div className="row">
        <div className="col-12 text-center my-5">
          <h4>A Quick And Easy 5-Step Process</h4>
        </div>
        <div className="col-sm-12 col-md-6 col-lg-6 col-xs-12 ">
          <div className="col-12 d-flex justify-content-center align-items-center">
            <img
              src={visitorManagementData[slideNo].image}
              alt=""
              style={{
                width: "60%",
                backgroundSize: "cover",
                backgroundRepeat: "no-repeat",
                filter: "drop-shadow(2px 4px 6px black)",
              }}
            />
          </div>
          <div className="col-12">
            <div
              className="carauselImageVMS"
              style={{
                width: "60%",
                height: "10px",
                backgroundColor: "transparent",
              }}
            ></div>
          </div>
        </div>
        <div className="col-sm-12 col-md-6 col-lg-6 col-xs-12 p-3 d-flex align-items-center">
          <div className="w-100">
            {Object.keys(visitorManagementData[slideNo].headings).map((key) => (
              <div
                className={` col-12 my-3 ${visitorManagementData[slideNo].headings[key][1]}`}
                style={{
                  transition: "background-color 1s ease",
                }}
              >
                <div className="row">
                  <div className="col-2 text-right">
                    <h4 className={` w-100 m-0`}>{`${key}. `}</h4>
                  </div>
                  <div className="col-10 text-left">
                    <h4 className={` w-100 m-0`}>
                      {`${visitorManagementData[slideNo].headings[key][0]}`}
                    </h4>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default VisitorManagementCarausel;
